import React from 'react';
import {
  Button,
  ButtonProps,
  Stack,
  SxProps,
  Typography,
  TypographyProps,
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { TP_COLORS } from '../../../../constants';
import { typoGradientStyles } from '../../../Home/components/AIMarkingSection';

const stackStyles: SxProps = {
  padding: '20px',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '10px',
  minHeight: '485px',
  backgroundColor: '#E5F7F6',
  border: '1px solid #73BFBC',
};

const titleTypoProps: TypographyProps = {
  color: TP_COLORS.tutopiyaGreenMain.darken,
  fontSize: '25px',
  fontWeight: '700',
  marginTop: '20px',
};

const subTitleTypoProps: TypographyProps = {
  color: TP_COLORS.gray.darken,
  maxWidth: '720px',
  textAlign: 'center',
  marginTop: '16px',
};

const buttonProps: ButtonProps = {
  disableElevation: true,
  variant: 'contained',
  sx: {
    width: '250px',
    height: '49px',
    fontSize: '16px',
    fontWeight: '600',
    marginTop: '69px',
  },
};

const PracticeQuestionLastPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Stack sx={{ ...stackStyles }}>
      <img
        src={`${process.env.PUBLIC_URL}/images/subtopicPage/star-struck-img.png`}
        alt="star-struck"
      />
      <Typography {...titleTypoProps}>
        Keep Going, You&apos;re Almost There!
      </Typography>
      <Typography {...subTitleTypoProps}>
        Nice job! 🎉You&apos;re on the right path! Now, take the quiz and get
        <span style={typoGradientStyles}> detailed feedback </span>
        on every answer with our
        <span style={typoGradientStyles}> AI-powered marking scheme.</span>{' '}
        Let&apos;s level up! 🚀
      </Typography>
      <Button {...buttonProps} onClick={() => navigate('quiz')}>
        Take me to Quiz
      </Button>
    </Stack>
  );
};

export default PracticeQuestionLastPage;
